import { AttributeTypes } from './../../../global-variables';
import {
  FrontEndColumn,
  ModelField,
} from '@app/shared/interfaces/front-end-column';
import { Attribute, Scope } from '@app/shared/interfaces/Attribute';
import { AttributeValue } from '@app/shared/interfaces/odata-response';
import { ProductService } from './services/product.service';
import { Observable, finalize, of, switchMap, tap } from 'rxjs';
import { Product } from './models/product';
import { AttributeDisplayProperty } from '@app/shared/interfaces/display-group';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FilterOperator } from './models/Enums.enum';
import { HardCopy } from 'src/global-variables';
import { FilterType } from '@app/shared/interfaces/front-end-column';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { ListPayload } from './models/ListPayload';
import { ProductsTableComponent } from '@product/list/products-table/products-table.component';
import { FilterLogicService } from './services/filter-logic.service';
import { EventEmitter } from '@angular/core';
export const productColumns: FrontEndColumn[] = [
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.String,
    label: 'Sku',
    name: 'sku',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.String,
    label: 'Description',
    name: 'name',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.Select,
    filterCode: 'Type',
    label: 'Type',
    name: 'type',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.Select,
    label: 'Status',
    name: 'status',
    filterCode: 'StatusId',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.Select,
    label: 'Attribute Set',
    name: 'attributeSet',
    filterCode: 'AttributeSetId',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.Date,
    label: 'Created At',
    name: 'createdAt',
    sortable: true,
    type: 'product',
  },
  {
    filterable: true,
    filterApplied: false,
    filterType: FilterType.Date,
    label: 'Updated At',
    name: 'updatedAt',
    sortable: true,
    type: 'product',
  },
  {
    filterable: false,
    filterApplied: false,
    filterType: FilterType.Select,
    label: 'Completion',
    name: 'completionSetId',
    filterCode: 'completionSetId',
    sortable: true,
    type: 'completion',
  },
  {
    filterable: false,
    filterApplied: false,
    filterType: FilterType.Select,
    label: 'Category',
    name: 'categories',
    filterCode: 'categories',
    sortable: false,
    type: 'categories',
  },
];

export const ProductModelFields: ModelField[] = [
  {
    Code: 'sku',
    DataType: AttributeTypes.String,
    Required: true,
    Title: 'Sku',
    Scope: Scope.Global,
    MaxLength: 100,
  },
  {
    Code: 'type',
    DataType: AttributeTypes.Select,
    Required: true,
    Title: 'Type',
    Scope: Scope.Language,
  },
  {
    Code: 'name',
    DataType: AttributeTypes.String,
    Required: true,
    Title: 'Name',
    Scope: Scope.Language,
    MaxLength: 200,
  },
  {
    Code: 'attributeSetId',
    DataType: AttributeTypes.Select,
    Required: true,
    Title: 'Attribute Set',
    Scope: Scope.Global,
  },
  {
    Code: 'statusId',
    DataType: AttributeTypes.Select,
    Required: false,
    Title: 'Status',
    Scope: Scope.Global,
  },
  {
    Code: 'completionSetId',
    DataType: AttributeTypes.Select,
    Required: false,
    Title: 'Completion Set',
    Scope: Scope.Global,
  },
  /*{
    Code: 'inheritFrom',
    DataType: AttributeTypes.Select,
    Required: false,
    Title: 'Inherit From',
    Scope: Scope.Global,
  },*/
];

// export const productTypes = [
//   {
//     Code: 'simple',
//     Label: 'Simple',
//   },
//   {
//     Code: 'grouped',
//     Label: 'Grouped',
//   },
 
// ];
export const productTypes = [
  {
    Code: 'simple',
    Label: 'Simple',
  },
  {
    Code: 'grouped',
    Label: 'Grouped',
  },
  {
    Code: 'configurable',
    Label: 'Configurable',
  },
];

//** Convert Form Attributes in format (type.id) to modelized attribute values */
export function ConvertToAttributeValues(
  attributes: any,
  selectedLanguage: number
): AttributeValue[] {
  if (
    attributes == null ||
    (attributes != null && Object.keys(attributes).length == 0)
  ) {
    return [];
  }
  const returnedAttributes: AttributeValue[] = [];
  Object.keys(attributes).forEach((key) => {
    const handledKey = key.split('.');
    const attributeId = handledKey[1];
    const attributeType = handledKey[0];
    if (attributeType === '12' && attributes[key] == null) {
      attributes[key] = false;
    }
    const attribute: AttributeValue = {
      AttributeId: +attributeId,
      LanguageId: selectedLanguage,
      Value: attributes[key]?.toString(),
      OptionValueId:
        +attributeType == AttributeTypes.Select ? attributes[key] : null,
    };
    returnedAttributes.push(attribute);
  });
  return returnedAttributes;
}

export function ConvertToFormAttributes(
  attributeValues: AttributeValue[],
  attributes: Attribute[]
) {
  if (
    attributeValues == null ||
    (attributeValues != null && Object.keys(attributeValues).length == 0)
  ) {
    return null;
  }
  const attributesToReturn: any = {};
  if (Array.isArray(attributeValues)) {
    if (attributes == null) {
      attributes = [];
    }
    attributeValues.forEach((attribute) => {
      const attr = attributes.find((x) => x.Id == attribute.AttributeId);
      if (attr == null) {
        return;
      }
      attributesToReturn[`${attr.Type}.${attr.Id}`] = attribute.Value;
    });
  } else {
    return attributeValues;
  }
  return attributesToReturn;
}
//  variantProducts: Product[],
export function PatchProductValues(
  service: ProductService,
  selectedId: number,
  selectedLanguage: number,
  formGroup: FormGroup,
  product: Product,

  attributesDisplaySettings: AttributeDisplayProperty[],
  completion: any,
  fb: FormBuilder,
  relatedProductsIds: number[],
  selectedCategories: number[],
  attributesToPatch: any,
  selectedProductTags: number[],
  isLoading: boolean,
  relatedProducts: Product[],
  parentAttributes: any,
  parentAttributeValues: any
) {
  return new Promise<any>((resolve, reject) => {
    const obs = service
      .getProduct(selectedId, selectedLanguage)
      .pipe(
        tap((result) => {
          product = result.product;
         // variantProducts = product.variants ?? [];
          attributesDisplaySettings = product.attributeDisplayProperties ?? [];
          completion = result.completion;
          if (product.type === 'configurable') {
            formGroup.addControl(
              'configurableProductProducts',
              new FormControl()
            );
          }

          if (
            product.productKitParents != null &&
            product.productKitParents.length > 0
          ) {
            const kitFormArray = formGroup.controls[
              'productKitParents'
            ] as FormArray;
            kitFormArray.clear();
            product.productKitParents.forEach((kit:any) => {
              kitFormArray.controls.push(
                fb.group({
                  parentId: [kit.skuNavigation ? kit.skuNavigation.id : null],
                  sku: [kit.sku],
                  quantity: [kit.quantity],
                })
              );
            });
          }

          if (
            product.productRelationshipProducts != null &&
            product.productRelationshipProducts.length > 0
          ) {
            const productRelationships = formGroup.controls[
              'productRelationshipProducts'
            ] as FormArray;
            relatedProductsIds = [];
            productRelationships.clear();
            product.productRelationshipProducts.forEach((rel) => {
              relatedProductsIds.push(rel.objectId);
              productRelationships.controls.push(
                fb.group({
                  productId: rel.productId,
                  objectId: rel.objectId,
                  objectType: rel.objectType,
                  relationId: rel.relationId,
                })
              );
            });
          }
          // set basic fields values
          const productCopy = HardCopy(product);
          delete productCopy.attributeValues;
          formGroup.patchValue(productCopy);

          // set selected Categories
          selectedCategories = [
            ...product.productCategories!.map((cat) => {
              return cat.categoryId;
            }),
          ];

          // set attributes that have values
          const attributes: any = {};
          let attributeValues = product.attributeValues;
          if (selectedLanguage !== 0) {
            attributeValues = attributeValues!.filter(
              (x) => x.languageId === selectedLanguage
            );
          }

          attributeValues!.forEach((att) => {
            if (attributes[att.attributeId] == null) {
              attributes[att.attributeId] = att.value;
            }
          });

          attributesToPatch = attributes;
          parentAttributeValues = HardCopy(product.attributeValues);
          //selected tags
          selectedProductTags = product.productTags!.map((x) => x.tagId);
          isLoading = false;
        }),
        switchMap(() => {
          if (relatedProductsIds.length > 0) {
            return service.getProductsList({
              PageSize: 0,
              PageIndex: 0,
              SortBy: 'Id',
              IsAscend: false,
              Filters: {
                Id: {
                  Type: FilterType.Number,
                  Operator: FilterOperator.inList,
                  Value: '',
                  Values: relatedProductsIds,//.join(','),
                  AdditionalInfo: '',
                },
              },
            });
          } else {
            return of(null);
          }
        }),
        tap((products) => {
          relatedProducts = products?.records!;
        }),
        switchMap(() => {
          if (product.type === 'variant') {
            return service.getParentAttributeValues(product.id!);
          } else {
            return of(null);
          }
        }),
        tap((attValues: any) => {
          if (attValues == null) {
            return;
          }
          parentAttributeValues = attValues;
          parentAttributes = (attValues as any[]).map((x) => x.attributeId);
          const valuesToPatch = (attValues as any[]).filter(
            (x) =>
              !Object.keys(attributesToPatch).includes(x.attributeId.toString())
          );
          valuesToPatch.forEach((value) => {
            attributesToPatch[value.attributeId] = value.value;
          });
          formGroup.controls['attributeValues'].patchValue(attributesToPatch);
        }),
        finalize(() => {
          obs.unsubscribe();
          resolve({
            product,
            //variantProducts,
            attributesDisplaySettings,
            completion,
            relatedProductsIds,
            selectedCategories,
            attributesToPatch,
            selectedProductTags,
            isLoading,
            relatedProducts,
            parentAttributes,
            parentAttributeValues,
          });
        })
      )
      .subscribe();
  });
}

export function ShowProductsToInherit(
  drawerService: NzDrawerService,
  filterService: FilterLogicService,
  getProductsToInherit: any,
  productId: number
) {
  return new Promise<Product>((resolve, reject) => {
    const payload: ListPayload = {
      Filters: {},
      IsAscend: false,
      PageIndex: 0,
      PageSize: 20,
      SortBy: 'Id',
    };
    let products: Product[] = [];
    const filterChange$: EventEmitter<any> = new EventEmitter();
    const drawer = drawerService.create({
      nzContent: ProductsTableComponent,
      nzContentParams: {
        products: products,
        payload: payload,
        isLoading: true,
        singleSelection: true,
        withActions: false,
        headerFiltersChanged: filterChange$,
      },
      nzTitle: 'Choose a product',
      nzWrapClassName: 'drawer-size-4x',
    });
    let component: ProductsTableComponent | null;
    const getProducts$ = getProductsToInherit(productId, payload).pipe(
      tap((response: Product[]) => {
        component!.products = [...response];
        component!.isLoading = false;
      })
    );
    const open$ = drawer.afterOpen
      .pipe(
        tap(() => {
          component = drawer.getContentComponent();
        }),
        switchMap(() => getProducts$)
      )
      .subscribe();

    const filter$ = filterChange$.subscribe((t) => {
      component!.isLoading = true;
      filterService.handleFiltersChanges(t, payload, () => {
        getProductsToInherit(productId, payload)
          .pipe(
            tap((response: Product[]) => {
              component!.products = [...response];
              component!.isLoading = false;
            })
          )
          .subscribe();
      });
    });
    const close$ = drawer.afterClose.subscribe(() => {
      const instance = drawer.getContentComponent() as ProductsTableComponent;
      const productsArr = Array.from(instance.setOfSelectedProducts);
      resolve(productsArr[0]);
      close$.unsubscribe();
      filter$.unsubscribe();
      open$.unsubscribe();
    });
  });
}
